import './Breadcrumb.less';
import React, {useContext} from 'react';
import BreadcrumbContext from "../../../contexts/breadcrumb/BreadcrumbContext";
import Icon from "../../../../bootstrap/components/icon/Icon";
import {Link} from "react-router-dom";


export default function Breadcrumb({}) {

    const breadcrumb = useContext(BreadcrumbContext);

    if (breadcrumb.items.length === 0) {
        return null;
    }

    const focusedBreadcrumbItem = breadcrumb.items[breadcrumb.items.length - 1];

    return <div className="breadcrumb">
        <div className="blurred">
            {
                breadcrumb.items
                    .slice(0, -1) // remove last item
                    .reduce((result, obj) => result.concat([obj, null]), [])
                    .map((item, index) => item !== null
                        ? <Link key={index} className="item" to={item.link}>{item.name}</Link>
                        : <Icon name="angle-right" key={index}/>
                    )
            }
        </div>
        <div className="focused">
            <a className='item' href={focusedBreadcrumbItem.link}>
                {focusedBreadcrumbItem.name}
            </a>
        </div>
    </div>;
}
